import { DataDescribed } from '@cs/core';

// tslint:disable-next-line
export type ApprovalOverviewData = Array<{ [key: string]: any }>;

export class ApprovalOverviewDataDescribed extends DataDescribed<ApprovalOverviewData> {

}
